export default {
    CATALOG: 'catalog',
    INVENTORY_USED: 'inventory-used',
    INVENTORY_NEW: 'inventory-new',
};



// WEBPACK FOOTER //
// ./src/constants/TileModes.js